// 放一些公共模块 比如登录 权限、文件上传等
import { request } from '@umijs/max';
import {
  GET_USER_INFO,
  POST_LOGIN,
  GET_NEW_TOKEN,
  GET_OPERATION_LOG,
  POST_UPLOAD,
  EDIT_PASSWORD,
  WECHAT_WORK_LOGIN,
  DEPARTMEN_TTREE,
  EMPLOYEE,
  OSS_SIGNATURE,
} from './api';
import apis from '../apis';

/**
 * 登录
 */
export async function login(data: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.CommonRes<API.LoginData>>(POST_LOGIN, {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/**
 * 企业微信登录
 */
export async function loginByWechatWork(params) {
  return request<API.CommonRes>(WECHAT_WORK_LOGIN, {
    method: 'GET',
    params,
  });
}
/**
 * 获取当前登录的用户信息
 */
export async function getUserInfo(options?: { [key: string]: any }) {
  return request<API.CommonRes<API.User>>(GET_USER_INFO, {
    method: 'GET',
    ...(options || {}),
  });
}
/**
 * 获取当前登录的用户信息
 */
export async function getNewToken(refreshToken: string, options?: { [key: string]: any }) {
  return request<API.CommonRes<{ access_token: string; token_type: string }>>(GET_NEW_TOKEN, {
    method: 'POST',
    data: {
      refresh_token: refreshToken,
    },
    ...(options || {}),
  });
}
/**
 * 获取操作日志
 */
export async function getOperationLog(
  params: API.OperationLogParams,
  options?: { [key: string]: any },
) {
  return request<API.PageRes<API.OperationLogItem>>(GET_OPERATION_LOG, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 * 通用上传文件
 */
export async function uploadFile(data: FormData, options?: { [key: string]: any }) {
  return request<
    API.CommonRes<{
      bucket_name: 'fire-control';
      file_name: string;
      url: string;
    }>
  >(POST_UPLOAD, {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/**
 * 修改密码
 */
export const editPassword = async (id, data) =>
  request<any>(`${apis.api}/admin/employee/${id}`, {
    method: 'PATCH',
    data,
  });

/**
 * 修改员工信息
 */
export const editEmployee = async (id, data) =>
  request<any>(`${apis.api}/admin/employee/${id}`, {
    method: 'PATCH',
    data,
  });
/**
 * 获取组织架构
 */
export async function getDepartment() {
  return request<API.CommonRes<any>>(DEPARTMEN_TTREE, {
    method: 'GET',
  });
}

/**
 * 获取员工
 */
export async function getEmployee(
  params: { department?: string; name?: string; isManager?: 1 | 0 } = {},
) {
  return request<API.CommonRes<any>>(EMPLOYEE, {
    method: 'GET',
    params,
  });
}

/**
 * 获取项目总监列表
 */
export async function getProjectDirector() {
  return {
    data: [
      { label: 'aa', value: 'all' },
      { label: 'Unresolved', value: 'open' },
      { label: 'Resolved', value: 'closed' },
      { label: 'Resolving', value: 'processing' },
    ],
  };
  // return request<API.CommonRes<any>>(PROJECT_DIRECTOR, {
  //   method: 'GET',
  //   params: { department },
  // });
}

/**
 * 获取项目总监列表
 */
export async function get() {
  return {
    data: [
      { label: 'aa', value: 'all' },
      { label: 'Unresolved', value: 'open' },
      { label: 'Resolved', value: 'closed' },
      { label: 'Resolving', value: 'processing' },
    ],
  };
  // return request<API.CommonRes<any>>(PROJECT_DIRECTOR, {
  //   method: 'GET',
  //   params: { department },
  // });
}

/**
 * 获取阿里云oss签名
 */
export interface OSSDataType {
  host: string;
  accessId: string;
  policy: string;
  signature: string;
  dir: string;
}

export async function getAliyunOss() {
  return request<API.CommonRes<OSSDataType>>(OSS_SIGNATURE, {
    method: 'GET',
  });
}

